import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllDawaaAction,
  GetDawaaByIdAction,
} from "../../../../redux/actions/DawaAction";
import axios from "axios";
import fileDownload from "js-file-download";
import notify from "../../../Notifcation";
import {
  CreateAjendaAction,
  DeleteAjendaAction,
  GetAllAjendaAction,
  UpdateAjendaAction,
} from "../../../../redux/actions/AjendaAction";
import { ToastContainer } from "react-toastify";
import NamemowakelSearchAj from "../../popups/Namemowakelsearch/Namemowakelsearch";
import { useDownloadExcel } from "react-export-table-to-excel";
import AjindaPrint from "../AjindaPrint";

import Pagination from "../../../Utility/Pagination/Pagination";
import { useReactToPrint } from "react-to-print";
const filter = createFilterOptions();
const Enter = ({
  userData,

  Filee,
  setFilee,
  FileeBase64,
  setBase64,
  Datee,
  setDatee,
  Dategalasa,
  setDategalasa,
  Namemowakell,
  setNamemowakell,
  Sefamo,
  setSefamo,
  NameKhesm,
  setNameKhesm,
  SefaKhesm,
  setSefaKhesm,
  TypeDawa,
  setTypeDawa,
  NumberDawa,
  setNumberDawa,
  Year,
  setYear,
  Mawdodawa,
  setMawdodawa,
  TakadyDegree,
  setTakadyDegree,
  Mahkamaa,
  setMahkama,
  Numbercircle,
  setNumbercircle,
  Typecircle,
  setTypecircle,
  SummaryDawa,
  setSummaryDawa,
  Nots,
  setNots,
  NotsImg,
  setNotsImg,
  Qarar,
  setQarar,
  selectedFile,
  setSelectedFile,
  setIsEdit,
  isEdit,
  setEye,
  Eye,
  setAjendaID,
  AjendaID,
}) => {
  const [showName, setshowName] = useState(false);
  const dispatch = useDispatch();
  const [isPress, setIsPress] = useState(false);
  const [Loading, setLoading] = useState(true);
  const myDivRefWorkcom = useRef();
  const [Search, setSearch] = useState("");
  const [DawaID, setDawaID] = useState(null);

  const PageSize = 7;
  const [showDelete, setshowDelete] = useState(false);
  const ALLDawa = useSelector((state) => state.DawaR.Getdawa);
  const OneDawa = useSelector((state) => state.DawaR.GetdawaId);
  const AllAjenda = useSelector((state) => state.AjendaR.getAjenda);
  const tableRef = useRef("");
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "ادارة الاجندة",
    sheet: "ادارة الاجندة",
  });
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAjendaID(itemid);
  };

  useEffect(() => {
    // if (Namemowakell && Namemowakell.Id) {
    // dispatch(GetDawaaByIdAction(Namemowakell?.Id));
    if (DawaID != null) {
      if (OneDawa) {
        setSefamo(OneDawa.ClientType);
        setSefaKhesm(OneDawa.DefendentType);
        setNameKhesm(OneDawa.Defendents);
        setTypeDawa(OneDawa.LawSuitType);
        setNumberDawa(
          OneDawa && OneDawa.Number ? converterqoma(OneDawa.Number)[0] : ""
        );
        setMahkama(OneDawa.CourtName);
        setNumbercircle(OneDawa.LocationNumberName);
        setTypecircle(OneDawa.LocationTypeName);
      }
    }

    //}
  }, [OneDawa, DawaID]);

  const onPress = async (page) => {
    await dispatch(
      GetAllAjendaAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  useEffect(() => {
    dispatch(GetAllAjendaAction(`SearchTerm=${Search}&PageSize=${PageSize}`));
  }, [Search]);
  const handleCloseName = () => setshowName(false);
  const handleShowName = () => setshowName(true);

  useEffect(() => {
    dispatch(GetAllDawaaAction(`IsDone=false&IsForLawyerBook=true`));
  }, []);

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";

    if (userData.UsedSize >= userData.SubscriptionSizeOnS3) {
      notify(
        "تم استهلاك باقة الارشيف لزيادة السعة التخزينية التواصل معنا",
        "warn"
      );
      return;
    }
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };
      reader.readAsDataURL(e.target.files[0]);
    };
    // }

    input.click();
  }
  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const converterqoma = (msg) => {
    if (typeof msg === "string") {
      let parts = msg.split("-");
      return parts;
    }
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Datee === "" || Namemowakell === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.SubscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }

    if (
      userData.SubscriptionType === "User-not-subscriped" &&
      AllAjenda.Data &&
      AllAjenda.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 يومية إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "Subscription-not-approved" &&
      AllAjenda.Data &&
      AllAjenda.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 يومية إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Date", Datee);
    formData.append("ClientNames", Namemowakell);
    formData.append("ClientType", Sefamo);
    formData.append("DefendantNames", NameKhesm);
    formData.append("DefendantType", SefaKhesm);
    formData.append("LawSuitForm", TypeDawa);
    formData.append("LawSuitNumber", NumberDawa);
    formData.append("CourtName", Mahkamaa);
    formData.append("LocationTypeName", Typecircle);
    formData.append("LocationNumberName", Numbercircle);
    formData.append("Decision", Qarar);
    formData.append("DateOfNextSession", Dategalasa);
    formData.append("Description", Nots);
    formData.append("LawSuitId", DawaID);
    formData.append("File", selectedFile);
    formData.append("FileDescription", NotsImg);

    await dispatch(CreateAjendaAction(formData));
    setDatee("");
    setNamemowakell("");
    setSefamo("");
    setNameKhesm("");
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setDawaID(null);
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setFilee("");
    setQarar("");
    setDategalasa("");
    setNotsImg("");

    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const handlePrint = useReactToPrint({
    content: () => myDivRefWorkcom.current,
  });
  const Update = async (item) => {
    setAjendaID(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientNames);
    setSefamo(item.ClientType);
    setMahkama(item.CourtName);
    setDategalasa(item.DateOfNextSession);
    setQarar(item.Decision || "");
    setNameKhesm(item.DefendantNames);
    setSefaKhesm(item.DefendantType);
    setTypeDawa(item.LawSuitForm);
    setNumberDawa(item.LawSuitNumber);
    setNumbercircle(item.LocationNumberName);
    setNots(item.Description || "");
    setTypecircle(item.LocationTypeName);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = async (item) => {
    setAjendaID(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientNames);
    setSefamo(item.ClientType);
    setMahkama(item.CourtName);
    setDategalasa(item.DateOfNextSession);
    setQarar(item.Decision || "");
    setNameKhesm(item.DefendantNames);
    setSefaKhesm(item.DefendantType);
    setTypeDawa(item.LawSuitForm);
    setNumberDawa(item.LawSuitNumber);
    setNumbercircle(item.LocationNumberName);
    setNots(item.Description || "");
    setTypecircle(item.LocationTypeName);
    setIsEdit(false);
    setEye(true);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAjendaAction(AjendaID));
    setshowDelete(false);
    setAjendaID("");
    setDatee("");
    setNamemowakell("");
    setSefamo("");
    setNameKhesm("");
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setFilee("");
    setQarar("");
    setDategalasa("");
    setNotsImg("");
    setIsEdit(false);
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const res = useSelector((state) => state.AjendaR.inserAjenda);
  const UP = useSelector((state) => state.AjendaR.updateAjenda);
  const Del = useSelector((state) => state.AjendaR.deleteAjenda);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Datee === "" || Namemowakell === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Date", Datee);
    formData.append("Id", AjendaID);
    formData.append("Decision", Qarar);
    formData.append("DateOfNextSession", Dategalasa);
    formData.append("Description", Nots);
    formData.append("NewFile", selectedFile);
    formData.append("FileDescription", NotsImg);

    await dispatch(UpdateAjendaAction(formData));
    setDatee("");
    setNamemowakell("");
    setSefamo("");
    setNameKhesm("");
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setFilee("");
    setQarar("");
    setDategalasa("");
    setNotsImg("");
    setIsEdit(false);
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  useEffect(() => {
    if (Loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage ===
              "Great, Lawyer Book created Successfully"
          ) {
            dispatch(GetAllAjendaAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage ===
              "Great, lawyer book updated Successfully"
          ) {
            dispatch(GetAllAjendaAction(`PageSize=${PageSize}`));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (Del) {
        if (Del.StatusCode === 200 || Del.StatusCode === 201) {
          if (
            Del &&
            Del.ResponseMessage === "Great, Lawyer Book deleted Successfully"
          ) {
            dispatch(GetAllAjendaAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (Del.StatusCode !== 200 || Del.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [Loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Datee ? new Date(Datee).toLocaleDateString("en-GB") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                focused={isEdit || Eye}
                type="date"
                value={Datee}
                onChange={(e) => setDatee(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                disabled={isEdit}
                focused={isEdit || Eye}
                value={Namemowakell}
                onChange={(event, newValue) => {
                  setNamemowakell(
                    newValue && newValue.Clients ? newValue.Clients : ""
                  );
                  setDawaID(newValue && newValue.Id ? newValue.Id : null);
                  dispatch(GetDawaaByIdAction(newValue?.Id));
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  ALLDawa && ALLDawa.Data && ALLDawa.Data.length > 0
                    ? ALLDawa.Data
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Clients;
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <span> {option.Clients} </span> -
                    <span>
                      {" "}
                      {option.Number
                        ? converterqoma(option.Number)[0]
                        : null}{" "}
                    </span>
                  </li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموكل
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                onClick={handleShowName}
                style={{ color: "#1866ec" }}
                className="ty fa-solid fa-magnifying-glass"></i>
            </div>
            <div className="inp-container">
              <TextField
                label="صفة الموكل"
                inputProps={{ maxLength: 120 }}
                type="text"
                focused={isEdit || Eye}
                disabled={isEdit}
                variant="outlined"
                value={Sefamo}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="اسم الخصم"
                inputProps={{ maxLength: 120 }}
                type="text"
                focused={isEdit || Eye}
                variant="outlined"
                disabled={isEdit}
                value={NameKhesm}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                disabled={isEdit}
                inputProps={{ maxLength: 120 }}
                type="text"
                focused={isEdit || Eye}
                label="صفة الخصم"
                variant="outlined"
                value={SefaKhesm}
                //   className="ww"
              />
            </div>

            <div className="inp-container">
              <TextField
                disabled={isEdit}
                focused={isEdit || Eye}
                label="نوع الدعوى"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={TypeDawa}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="رقم الدعوى"
                disabled={isEdit}
                focused={isEdit || Eye}
                variant="outlined"
                inputProps={{ maxLength: 15 }}
                type="number"
                value={NumberDawa}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="اسم المحكمة"
                focused={isEdit || Eye}
                disabled={isEdit}
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={Mahkamaa}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                focused={isEdit || Eye}
                disabled={isEdit}
                label="نوع الدائرة"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Typecircle}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="رقم الدائرة"
                focused={isEdit || Eye}
                inputProps={{ maxLength: 15 }}
                type="number"
                disabled={isEdit}
                variant="outlined"
                value={Numbercircle}
                //   className="ww"
              />
            </div>

            {/* <div className="inp-container">
              <div className="dateee">{Datee ? Datee : null}</div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                
                label="تاريخ الجلسة السابقة"
                variant="outlined"
                type="date"
                value={Datee}
                onChange={(e) => setDate(e.target.value)}
              />
            </div> */}
            <div className="inp-container">
              <TextField
                focused={isEdit || Eye}
                label="القرار"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={Qarar}
                onChange={(e) => setQarar(e.target.value)}

                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {" "}
                {Dategalasa
                  ? new Date(Dategalasa).toLocaleDateString("en-GB")
                  : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="تاريخ الجلسة اللاحقة"
                focused={isEdit || Eye}
                variant="outlined"
                type="date"
                value={Dategalasa}
                onChange={(e) => setDategalasa(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <TextField
                focused={isEdit || Eye}
                label="ملاحظات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={Nots}
                onChange={(e) => setNots(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                focused={isEdit || Eye}
                label="أرشيف المستندات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={NotsImg}
                onChange={(e) => setNotsImg(e.target.value)}
                //   className="ww"
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {selectedFile && (
                <div className="fi">
                  <a
                    href={FileeBase64 ? FileeBase64 : selectedFile}
                    target="blank"
                    download={selectedFile.name}>
                    {selectedFile.name ? (
                      selectedFile.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>Attach File</div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd d">
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}></i>
                  </button>
                </div>
              )}

              <div className="inp-container"></div>
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {Loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {Loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                //   className="ww"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <ToastContainer autoClose={1200} />
        <div>
          <Table
            id="my-table"
            className="maint"
            responsive
            striped
            ref={tableRef}
            bordered
            hover>
            <thead>
              <tr>
                <th>
                  التاريخ<i className="fa-solid fa-hashtag"></i>
                </th>

                <th>
                  الموكل<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  صفة الموكل<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  نوع الدعوى<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th  style={{width: "200px"}}>
                  القرار <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  تاريخ الجلسة اللاحقة<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  ارشيف المستندات{" "}
                  <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
              </tr>
            </thead>
            <tbody>
              {AllAjenda && AllAjenda.Data && AllAjenda.Data.length > 0
                ? AllAjenda.Data.map((item, idx) => (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.Date).toLocaleDateString("en-GB")}</td>
                      <td>{item.ClientNames}</td>
                      <td>{item.ClientType}</td>
                      <td>{item.LawSuitForm}</td>
                      <td style={{width: "230px",display:"block"}}>{item.Decision}</td>
                      <td>  
                        {item.DateOfNextSession !== null
                          ? new Date(item.DateOfNextSession).toLocaleDateString(
                              "en-GB"
                            )
                          : ""}
                      </td>

                      <td>
                        {" "}
                        {item.FileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.FileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.FileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.Id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => HandleEye(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </Table>
          <Pagination
            onPress={onPress}
            PageSize={PageSize}
            PageCount={AllAjenda ? AllAjenda.TotalPages : null}
            // ForceCount={ForceCount}
            // itemsPerPage={2}
            // items={FilesDetails.data}
          />
        </div>
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <Modal
        show={showName}
        onHide={handleCloseName}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الموكلين</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NamemowakelSearchAj />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseName}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      {/* <Modal
        show={showPdf}
        onHide={handleClosePdf}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>بيانات الأجندة</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={myDivRefWorkcom}>
            <AjindaPrint
              Datee={Datee}
              Namemowakell={Namemowakell}
              Sefamo={Sefamo}
              Mahkamaa={Mahkamaa}
              Dategalasa={Dategalasa}
              Qarar={Qarar}
              NameKhesm={NameKhesm}
              SefaKhesm={SefaKhesm}
              TypeDawa={TypeDawa}
              NumberDawa={NumberDawa}
              Numbercircle={Numbercircle}
              Typecircle={Typecircle}
              Nots={Nots}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleClosePdf}>
            إغلاق
          </Button>
          <Button
            onClick={handlePrint}
            variant="primary"
            className="edit">
            طباعة
          </Button>
        </Modal.Footer>
      </Modal> */}
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div ref={myDivRefWorkcom}>
        <AjindaPrint
          Datee={Datee}
          Namemowakell={Namemowakell}
          Sefamo={Sefamo}
          Mahkamaa={Mahkamaa}
          Dategalasa={Dategalasa}
          Qarar={Qarar}
          NameKhesm={NameKhesm}
          SefaKhesm={SefaKhesm}
          TypeDawa={TypeDawa}
          NumberDawa={NumberDawa}
          Numbercircle={Numbercircle}
          Typecircle={Typecircle}
          Nots={Nots}
        />
      </div>
    </>
  );
};
export default Enter;
